import { productTypeOptions } from "constants/SelectFieldOptions"
import ProductType from "types/enums/ProductType"

const LABEL_BY_VALUE = Object.fromEntries(productTypeOptions.map(({ value, label }) => [value, label])) as Record<
  ProductType,
  string
>

export const getProductTypeLabel = (productType: string | undefined, isContractor = false): string | undefined => {
  if (!productType) return undefined
  if (isContractor && productType === ProductType.Thermostat) return "Nuve Thermostats"
  return LABEL_BY_VALUE[productType as ProductType]
}
